//fuel example
export const SAVE_FUEL_SAVINGS = 'SAVE_FUEL_SAVINGS';
export const CALCULATE_FUEL_SAVINGS = 'CALCULATE_FUEL_SAVINGS';

//counter
export const INCREMENT = 'INCREMENT';
export const DECREMENT = 'DECREMENT';

//todomvc
export const ADD_TODO = 'ADD_TODO';
export const DELETE_TODO = 'DELETE_TODO';
export const EDIT_TODO = 'EDIT_TODO';
export const COMPLETE_TODO = 'COMPLETE_TODO';
export const COMPLETE_ALL = 'COMPLETE_ALL';
export const CLEAR_COMPLETED = 'CLEAR_COMPLETED';

// todo filters
export const SHOW_ALL = 'show_all';
export const SHOW_COMPLETED = 'show_completed';
export const SHOW_ACTIVE = 'show_active';

//sign up
export const REGISTER = 'register';
export const SUCCESSFUL_REG = 'successful_reg';
export const FAILURE_REG = 'failure_reg';

//
export const ACTIVATION_ACCOUNT = 'ACTIVATION_ACCOUNT';
export const SAVE_ACCOUNT_ID = 'SAVE_ACCOUNT_ID';

//ACCOUNT INFO
export const SAVE_LICENSE_PLATE = 'SAVE_LICENSE_PLATE';
export const SAVE_BALANCE_ACCOUNT = 'SAVE_BALANCE_ACCOUNT';
export const SAVE_PHONE_NUMBER = 'SAVE_PHONE_NUMBER';
export const SAVE_ACCOUNT_SETTINGS = 'SAVE_ACCOUNT_SETTINGS';
export const SAVE_ACCOUNT_SETTINGS2 = 'SAVE_ACCOUNT_SETTINGS2';
export const SAVE_ACCOUNT_SETTINGS2_FAILER = 'SAVE_ACCOUNT_SETTINGS2_FAILER';
export const SAVE_ACCOUNT_SETTINGS_PROGRESS = 'SAVE_ACCOUNT_SETTINGS_PROGRESS';

export const SHOW_ACCOUNT_INFO = 'SHOW_ACCOUNT_INFO';

//prepaidCard
export const REFILL_PREPAID_CARD_SUCCESSFUL = "REFILL_PREPAID_CARD_SUCCESSFUL";
export const REFILL_PREPAID_CARD_FAILED = "REFILL_PREPAID_CARD_FAILED";

// CREDIT_CARD
export const UPDATE_BALANCE_TOPUPEWALLET_SUCCESSFUL = "UPDATE_BALANCE_TOPUPEWALLET_SUCCESSFUL";
export const UPDATE_BALANCE_TOPUPEWALLET_FAILED = "UPDATE_BALANCE_TOPUPEWALLET_FAILED";
export const CLOSE_HTML_FORM = "CLOSE_HTML_FORM";
export const SET_PAYMENT_STATUS = "SET_PAYMENT_STATUS";
export const SET_PAYMENT_STATUS_FAILED = "SET_PAYMENT_STATUS_FAILED";
export const SET_PAYMENT_STATUS_PROGRESS = "SET_PAYMENT_STATUS_PROGRESS";
export const SAVE_HTML_FORM = "SAVE_HTML_FORM";

//HISTORY
export const GET_HISTORY_SUCCESS     = "GET_HISTORY_SUCCESS";
export const GET_HISTORY_FAILED      = "GET_HISTORY_FAILED";
export const SEND_HISTORY_SUCCESSFUL = "SEND_HISTORY_SUCCESSFUL";
export const SEND_HISTORY_FAILED     = "SEND_HISTORY_FAILED";
export const SEND_HISTORY_PROGRESS    ="SEND_HISTORY_PROGRESS";

//ALERT
export const  ALERT_SUCCESS = "ALERT_SUCCESS";
export const  ALERT_FAILED = "ALERT_FAILED";
export const  NOT_SHOW_ALERT_MESSAGE = "NOT_SHOW_ALERT_MESSAGE";
export const  LOCATION_CHANGE = '@@router/LOCATION_CHANGE';



// WEBPACK FOOTER //
// ./src/constants/actionTypes.js